import {
    BombeoFormCaracteristicasFields,
    BombeoFormGeneralDataFields,
    BombeoFormElementosFields,
} from ".";

const BombeoModificationForm = ({section}) => {
    if (section === "generaldata") {
        return <BombeoFormGeneralDataFields layout="column" />;
    }
    if (section === "caracteristicas") {
        return <BombeoFormCaracteristicasFields layout="column" />;
    }
    if (section === "elementos") {
        return <BombeoFormElementosFields layout="column" />;
    }

    return null;
};

export default BombeoModificationForm;
